<template>
    <v-layout wrap px-12>
        <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#68D389"
      size="128"
      is-full-screen
    />
    
     <ServerError v-if="ServerError"/>
        <v-flex>
            
             <v-layout pt-5 pb-5 wrap justify-center text-center>
                 <v-flex text-left xs12  style="color: black; font-family: poppins-semibold; font-size: 30px">
                   {{blogData.title}}
                 </v-flex>
                   <v-flex xs12 text-left pb-3> <span class="text" style="font-family: poppins-regular ;color:green">
                 Posted on: {{ DateFormatted(blogData.createdAt) }}
                </span> </v-flex>
            </v-layout>
            
             <v-layout wrap justify-center text-center>
                 <v-flex xs12  style="color: black; font-family: poppins-light; font-size: 18px">
                 <span v-html="blogData.text"> </span>  
                 </v-flex>
            </v-layout>
             <v-layout>
        <v-flex>
          <v-dialog v-model="value" width="900px"  v-if="blogData.image" >
                <v-card >
                <v-img
            width="900"
          contain
            :src="mediaURL + blogData.image"
          ></v-img>
                </v-card>
              </v-dialog>
        </v-flex>
      </v-layout> 

        </v-flex>
    </v-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
    props:["id"],  
    data()
    {
        return{
            value:false,
            blogData:[],
            appLoading:false,
            ServerError :false,
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
         DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
    },
        getData(){
            this.appLoading =true;
            axios({
                method:"GET",
                url:"blog/get",
                params:{
                 id:this.id
                }
            })
            .then((response) =>
            {
                if(response.data.status)
                {
                    this.blogData = response.data.data;
                    console.log(this.blogData)
                }
               this.appLoading =false;
            })
            .catch((err) =>{
                console.log(err())
              this.ServerError =true;
            })
            
        }
    }
}
</script>